var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenRectangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 45,
    viewBox: "0 0 118 45",
    fill: "red",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.673 0.704196V13.12H117.374V0H104.254V0.700166L116.673 0.704196Z",
    fill: "#CCFD34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.704305 0.704722H13.12V0.00444031H0V13.1244H0.700398L0.704305 0.704722Z",
    fill: "#CCFD34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.683 44.2305H104.267V44.9307H117.387V31.8107H116.687L116.683 44.2305Z",
    fill: "#CCFD34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.70433 44.2303V31.8145H0.00439453V44.9345H13.1244V44.2342L0.70433 44.2303Z",
    fill: "#CCFD34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRectangle);
export default __webpack_public_path__ + "static/media/greenRectangle.c3da693334c31e64bb1db98ae0b003fe.svg";
export { ForwardRef as ReactComponent };